/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Limesschule1Inputs */

const en__field_enum_limesschule1 = /** @type {(inputs: _Field_Enum_Limesschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altenstadt`)
};

const de__field_enum_limesschule1 = /** @type {(inputs: _Field_Enum_Limesschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limesschule`)
};

/**
* | output |
* | --- |
* | "Altenstadt" |
*
* @param {_Field_Enum_Limesschule1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_limesschule1 = /** @type {((inputs?: _Field_Enum_Limesschule1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Limesschule1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_limesschule1(inputs)
	return de__field_enum_limesschule1(inputs)
});
export { _field_enum_limesschule1 as "_field_enum_Limesschule" }